import { getSupabaseClient } from "../providers/supabase/supabase";

export interface AutomationRunResult {
  claimed: number;
  results: Array<{
    id: number;
    status: "sent" | "failed";
    error?: string;
    /** false when the order went out but the activities audit insert failed */
    auditLogged?: boolean;
    /** false when the order went out but the job row could not be marked sent */
    persisted?: boolean;
  }>;
}

/**
 * Invoke the `automations` edge function with the signed-in user's JWT.
 * Drains that user's `approved` jobs — pass job_ids to target specific ones,
 * or nothing to flush everything queued (the Outbox does this on load so a
 * job approved during a network hiccup is never stranded).
 */
export async function runAutomations(
  jobIds?: Array<number | string>,
): Promise<AutomationRunResult> {
  const { data, error } = await getSupabaseClient().functions.invoke(
    "automations",
    { body: jobIds?.length ? { job_ids: jobIds.map(Number) } : {} },
  );
  if (error) throw new Error(error.message ?? "automations invoke failed");
  if (!data?.success) throw new Error(data?.error ?? "automations run failed");
  return data.data as AutomationRunResult;
}
